/*!
 * React FormControl Library v3.6.0 for FormEngine
 * 
 * Copyright Gars Infotech Private Limited / Xio Infotech Private Limited Foundation and other contributors
 * Released under the MIT license
 * 
 * 
 * Date: 2022-03-02T17:08Z
 * Copyright (c) <2022> <Xio Infotech Private Limited>
 * The MIT License is not the only permissive license. Other well-known permissive licenses include: Apache 2.0, BSD.
 */
 import React from "react";
import Switch from "@material-ui/core/Switch";
// import useStyles from "../Component/Theme_1/FormControlsCss";
import ThemeControls from "../Component/AllThemesControl";
export default function SwitchLabels(props) {
  const {useStyle} = ThemeControls;
  const classes=useStyle();
  const { name, color, onChange,disabled, checked } = props;
 
  return (
    <div className={classes.switch}>
      <Switch 
        // color={color}
        disabled={disabled}
        checked={checked}
        onChange={onChange}
        name={name}
      />
    </div>
  );
}
